import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Close from "@mui/icons-material/Close";
import { Box, IconButton } from "@mui/material";
import { useTranslation } from "react-i18next";

import { FormTitle } from "../FormTitle/FormTitle.js";

interface PopupDialogProps {
  titleText?: string;
  subtitleText?: string;
  closeDialog: () => void;
  removeMarginBottom?: boolean;
  hideCloseButton?: boolean;
  /** Optional back action — when provided, renders an arrow-back button to the left of the title */
  backAction?: () => void;
}

export const PopupDialogTitle = ({
  titleText,
  subtitleText,
  closeDialog,
  removeMarginBottom,
  hideCloseButton,
  backAction,
}: PopupDialogProps) => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        ...(!removeMarginBottom && { mb: 4 }),
      }}
    >
      <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}>
        {backAction && (
          <IconButton
            aria-label={t("buttonLabels.back")}
            onClick={backAction}
            size="small"
            sx={{ mt: 0.5 }}
          >
            <ArrowBackIcon fontSize="small" />
          </IconButton>
        )}
        <FormTitle
          titleText={
            titleText || t("pages.patientHome.launchForm.confirmAction")
          }
          subtitleText={subtitleText}
          hasContainerMarginBottom={false}
          hasTitleBottomMargin={false}
          useReducedTopPadding={true}
        />
      </Box>
      {!hideCloseButton && (
        <IconButton
          sx={{
            width: "40px",
            height: "40px",
          }}
          data-testid="close-dialog"
          aria-label={t("buttonLabels.close")}
          onClick={closeDialog}
        >
          <Close sx={{ color: "primary.hint" }} fontSize="small" />
        </IconButton>
      )}
    </Box>
  );
};
